import React from 'react'

import * as THREE from "three";
import { v } from '../../env/env_variable';


function Ring(props) {
    const planet = props.planet
    // Ring System:
    // Check if the planet is Saturn and has rings
    const hasRing = planet.rings && planet.rings;
    
    // Load the texture for Saturn's rings
    let ringsTexture, ringsPosition, ringsRotation

    if(hasRing){
        ringsTexture = hasRing
        ? new THREE.TextureLoader().load(require(`${planet.rings.textures.base}`))
        : null;
  
  
        // Calculate the position of the rings based on the innerRadius
        ringsPosition = [
            planet.rings.innerRadius * 100 / v.scale, // Use the innerRadius for X-coordinate
            100, // Use the same Y-coordinate for both planet and rings
        ];
    
        // Calculate the rotation to make rings horizontal (rotate around X-axis)
        ringsRotation = [-Math.PI / 2, 0, 0]; // Rotate 90 degrees around the X-axis
  
    }
    




    // [planet.rings.innerRadius * 100 / v.scale, planet.rings.outerRadius * 100 / v.scale, 100]
  return (
    <mesh>
        {hasRing && (
            <mesh 
                rotation={ringsRotation}
            >
                <ringGeometry
                    args={props.planetPosition}
                />
                <meshStandardMaterial map={ringsTexture} color={"white"} transparent={true} side={THREE.DoubleSide} />
            </mesh>
        )}
    </mesh>
  )
}

export default Ring